module.exports = __webpack_public_path__ + "static/img/3.a0a7ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/3.png
// module id = J1xC
// module chunks = 12